/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Embed_Captions_Upload_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to upload video file: {error}" |
*
* @param {Embed_Captions_Upload_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_upload_failed = /** @type {((inputs: Embed_Captions_Upload_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Upload_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec du televersement du fichier video : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Videodatei konnte nicht hochgeladen werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile caricare il file video: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось загрузить видеофайл: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo cargar el archivo de vídeo: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`视频文件上传失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ビデオファイルのアップロードに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वीडियो फ़ाइल अपलोड करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao carregar o arquivo de vídeo: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to upload video file: ${i?.error}`)
});